// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as ClockDefault } from '../../../assets/icons/default/time/clock.svg?react';
import { ReactComponent as ClockSolid } from '../../../assets/icons/solid/time/CLOCK.svg?react';
import { createIcons } from '../../Icon';
const ClockIcon = /* @__PURE__ */ createIcons('Clock', {
    default: ClockDefault,
    solid: ClockSolid
});
ClockIcon.supportedTypes = ['default', 'solid'];
ClockIcon.category = 'time';
export default ClockIcon;
